import * as React from 'react';
import { DeviceType, Product, AlgoliaIndiceName } from '@packages/common';

import { AlgoliaContext } from '../context';
import { AlgoliaSearchParams } from '../types';
import { useAlgoliaResponse } from './useAlgoliaResponse';

export const useProductSearch = (
  { queryParameters, indiceName = AlgoliaIndiceName.PRODUCTS, deviceType = DeviceType.desktop }: AlgoliaSearchParams,
  bail = false,
) => {
  const { productSearch } = React.useContext(AlgoliaContext);
  return useAlgoliaResponse<Product, any>(
    productSearch,
    {
      queryParameters,
      deviceType,
      indiceName,
    },
    bail,
  );
};

export const useProductSearchById = (
  productIds: string[],
  idKey: 'objectID' | 'productId' = 'objectID',
  disableCategoryZero = false,
  hitsPerPage = 0,
  deviceType = DeviceType.desktop,
) => {
  let filters = 'productId:0'; // Bail if no product ids
  if (productIds.length > 0) {
    const categoryZeroFilter = disableCategoryZero ? '' : 'category:0 AND ';
    filters = `${categoryZeroFilter}${productIds.map((id) => `${idKey}:${id}`).join(' OR ')}`;
  }
  return useProductSearch(
    {
      queryParameters: {
        filters,
        ...(hitsPerPage ? { hitsPerPage } : {}), //if nothing passed, algolia defaults to 20
      },
      deviceType,
    },
    productIds.length === 0,
  );
};
